// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Modal-components-ModalHeader-ModalHeader-module__ModalHeader";
var _2 = "webpack-components-core-Modal-components-ModalHeader-ModalHeader-module__ModalHeaderHeading";
export { _1 as "ModalHeader", _2 as "ModalHeaderHeading" }
